module.exports = __webpack_public_path__ + "media/images/philanthropy-logos/logo-acs-2e0fdb47cad360a0c0a30a0f85fd916a.svg";